import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { ShareService } from '@app/shared/services/vault/share.service';

import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { BankGroup, TRANSACTIONGROUPS } from '@app/modules/vault/components/add-document/attribute-section/add-attribute-poup/demo-data';
import { TaskItemDialogComponent } from '@app/modules/vault/components/dialogs/task-item-dialog/task-item-dialog.component';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { UserService } from '@app/shared/services';
import { AddCategoryComponent } from '../add-category/add-category.component';
import { DocumentService } from '@app/shared/services';
import { AttributesDialogComponent } from '@app/modules/vault/components/add-document/insurance-attributes/attributes-dialog/attributes-dialog.component';
import { SharedConfirmationDialogComponent } from '../shared-confirmation-dialog/shared-confirmation-dialog.component';
import { HttpClient } from '@angular/common/http';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

enum EAttributesTypes {
  financialAttribute = 'financial-attribute',
  insuranceAttribute = 'insurance-attribute',
}

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'register-balance-2',
  templateUrl: './register-balance-2.component.html',
  styleUrls: ['./register-balance-2.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterBalance2Component implements OnInit, OnDestroy {
  @ViewChild('tableContainer') tableContainer: ElementRef;
  // @ViewChild('expenseIncomeCategory') expenseIncomeCategory: AddCategoryComponent;
  @ViewChild('valueInput') valueInput: ElementRef;
  @ViewChild('register_balance-container') registerContainer: ElementRef;
  @Input() allTransaction = false;
  @Output() updateEmit = new EventEmitter();
  @Output() getTransactionEventTriggered: EventEmitter<any> = new EventEmitter<any>();
  @Output() distributionBalanceEmitter = new EventEmitter<number>();

  closeTransactionDialog: EventEmitter<void> = new EventEmitter<void>();

  displayedColumns: string[] = ['date', 'value', 'add'];
  dataSource = new MatTableDataSource<any>();
  @Input() data: any;
  userId$;
  RegisterForm: FormGroup;
  paginationNo;
  noMoreEntry;
  transactionType;
  selectAll = false;
  showEmptyEntry = false;
  disableReviewButton = false;
  disableDeleteButton = false;
  disableCategoryButton = false;
  checkReviewStatus = '';
  defaultSort = 'date';
  sortedArrayByDate = false;
  sortedArrayByReview = false;
  infinityValue;
  fid;
  screenWidth;
  linkedItems;
  selectedDate;
  todayDate: Date;
  linkedItemArray = [];
  registerArray = [];
  selectedEntryArray: Array<any> = [];
  stateObject;
  vaultStateObject$: any;
  subscription = new Subscription();
  loaderItems = [{ id: 1 }, { id: 2 }, { id: 3 }];

  selectedRowIndex;
  styleElement: HTMLStyleElement;
  protected areas: BankGroup[] = TRANSACTIONGROUPS;
  selectedAreas: BankGroup[] = this.areas;
  isOpen = false;
  showReviewedItems: boolean = false;
  showReviewedItemsOnly: boolean = false;
  getScreenHeight;
  getTableHeight;
  estimatedHeight;
  isBrowserSafari;
  editCategoryClicked;
  lastItems;
  canCreateIncomeExpense;
  selectedCategories = [];
  incomeCategories = [];
  expenseCategories = [];
  isExpenseIncomeCategoryDropdownOpen = false;
  financialAttributes;
  @Input() isFromDistribution = false;

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenHeight = window.innerHeight;
  }

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public receivedData: any,
    // private dialogRef: MatDialogRef<RegisterBalanceComponent>,
    private _formBuilder: FormBuilder,
    private shareService: ShareService,
    private userService: UserService,
    private loginService: LoginStoreEffects,
    private vaultService: VaultStoreEffects,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private changeDetector: ChangeDetectorRef,
    private renderer: Renderer2,
    private documentService: DocumentService,
    private http: HttpClient
  ) {
    this.vaultStateObject$ = this.vaultService.vaultObject;
    this.subscription.add(
      this.vaultStateObject$.subscribe((item) => {
        this.stateObject = item;
        this.changeDetector.markForCheck();
      })
    );

    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state && state.data && state.data.id) {
          this.userId$ = state?.data?.id;
          this.changeDetector.detectChanges();
        }
      })
    );

    this.RegisterForm = this._formBuilder.group({
      RegisterRows: this._formBuilder.array([]),
    });
    if (!this.isFromDistribution) {
      if (Object.keys(receivedData).length !== 0) this.data = this.receivedData;
      if (Object.keys(receivedData).length == 0) {
        this.data = this.receivedData;
      }
    }
    const now = new Date();
    this.todayDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);

    this.areas = TRANSACTIONGROUPS;
    this.selectedAreas = this.areas;
  }

  ngOnInit(): void {
    this.financialAttributes = this.data.financialAttributes;
    this.getScreenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    this.isBrowserSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.paginationNo = 0;
    if (this.isFromDistribution) {
      this.receivedData = this.data;
    }
    this.getBalance();
  }

  get RegisterRows() {
    return this.RegisterForm.controls['RegisterRows'] as FormArray;
  }

  ngAfterViewInit() {
    this.getTableHeight = this.tableContainer.nativeElement.offsetHeight;
  }

  getMoreData() {
    this.paginationNo = this.registerArray.length;
    this.getBalance();
  }
  deleteRegisterEntry() {
    const ids = this.selectedEntryArray.map((item) => item.id);
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '500px',
      data: {
        title: 'Delete Records?',
        materialIcon: 'delete',
        text: `Are you sure you want to delete all records?`,
        proceedTitle: 'Delete',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.handleDeleteBalanceData({
            ids: ids,
            vault_user_form_id: this.receivedData?.currentFormId,
          });
        }
      })
    );
  }
  // attributesList = [];
  registerKeys = [];
  getBalance() {
    this.handleJson();
    let userId = this.data?.currentuserId ? this.data?.currentuserId : this.data?.currentValutUserId;
    let type = this.receivedData?.balanceType ?? this.receivedData?.balanceData?.register_type;
    // const attributesList = this.data?.attribute?.value?.Register_keys;
    this.registerKeys = this.getInputsByRegisterKeys(this.data?.attribute);

    // this.attributesList = attributesList;
    this.subscription.add(
      this.shareService.getBalanceEntry(userId, this.receivedData?.currentFormId, 0, type).subscribe(
        (data) => {
          this.noMoreEntry = data.loadMore;
          this.registerArray = [];
          data?.balanceData?.forEach((element, i) => {
            !!element.additional_data ? this.registerArray.push(element) : '';
          });
          this.showEmptyEntry = this.registerArray.length == 0 ? true : false;

          this.RegisterForm = this._formBuilder.group({
            RegisterRows: this._formBuilder.array(
              this.registerArray.map((val, index) => {
                // let
                // if (this.registerKeys.length < 2) {
                let formControls: any = {
                  id: new FormControl(val.id),
                  date: new FormControl(val.effective_date),
                  value: new FormControl(this.getAttributeValue(this.registerKeys[0].key, val)),
                  action: new FormControl('existingRecord'),
                  isDateEditable: new FormControl(true),
                  add: new FormControl(true),
                  isAmountEditable: new FormControl(true),
                  isNewRow: new FormControl(false),
                  selected: new FormControl(false),
                  updated_by: new FormControl(val?.updated_by ?? ''),
                  source_img: new FormControl(val?.source_img ?? ''),
                  valueTwo: new FormControl(''),
                  isValueTwoEditable: new FormControl(false),
                  currency: new FormControl(this.getCurrency(val)),
                };
                // } else
                if (this.registerKeys.length == 2) {
                  formControls = {
                    ...formControls,
                    valueTwo: new FormControl(this.getAttributeValue(this.registerKeys[1].key, val)),
                    isValueTwoEditable: new FormControl(true),
                  };
                  const valueIndex = this.displayedColumns.indexOf('value');
                  const insertIndex = type === 'has_distribution' ? valueIndex : valueIndex + 1;
                  this.displayedColumns.some((val) => val.includes('value_two')) ? '' : this.displayedColumns.splice(insertIndex, 0, 'value_two');

                  this.changeDetector.detectChanges();
                  return this._formBuilder.group(formControls);
                } else {
                  this.changeDetector.detectChanges();
                  return this._formBuilder.group(formControls);
                }
              })
            ),
          });
          const tSum = this.getSumOfCommitments(this.registerArray);
          this.distributionBalanceEmitter.emit(tSum);

          this.dataSource = new MatTableDataSource((this.RegisterForm.get('RegisterRows') as FormArray).controls);
          this.changeDetector.detectChanges();
        },
        (error) => {
          this.toastr.error(error);
        }
      )
    );
    this.dataSource = new MatTableDataSource((this.RegisterForm.get('RegisterRows') as FormArray).controls);
    this.changeDetector.detectChanges();
  }
  allAttributeData;
  handleJson() {
    this.subscription.add(
      this.documentService.getInsuranceAttribute().subscribe(
        (data) => {
          this.allAttributeData = { ...data };
          this.changeDetector.detectChanges();
        },
        (error) => {
          console.error(error);
        }
      )
    );
    this.subscription.add(
      this.documentService.getFinancialAttribute().subscribe(
        (data) => {
          this.allAttributeData = { ...this.allAttributeData, ...data };
          this.changeDetector.detectChanges();
        },
        (error) => {
          console.error(error);
        }
      )
    );
  }
  checkItemExist(item: string) {
    return this.data?.attribute?.value?.Register_keys?.includes(item);
  }
  getInputsByRegisterKeys(data) {
    const registerKeys = data?.value?.Register_keys ?? [];
    const inputs = data?.value?.inputs;
    const inputsWithRegisterKeys = [];

    inputs?.forEach((input) => {
      if (registerKeys.includes(input?.key)) {
        inputsWithRegisterKeys.push(input);
      }
    });

    return inputsWithRegisterKeys ?? [];
  }

  getTitle(key: string) {
    return this.registerKeys.find((item) => item.key == key)?.title ?? key;
  }
  createBalance(date, value) {}

  updateBalance(id, date_, value, createMode = false) {
    const date = new Date(date_);
    const exist = this.registerArray.find((item) => item.id == id);
    const item = JSON.parse(exist?.additional_data) ?? {};
    const additional_data = {
      ...item,
      [this.receivedData?.attribute?.value?.Register_keys[this.receivedData?.attribute?.value?.Register_keys.includes('Date') ? 1 : 0]
        .replace(/\s+/g, '_')
        .toLowerCase()]: value,
    };
    const payload = {
      ...exist,
      effective_date: `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`,
      value,
      additional_data: JSON.stringify(additional_data),
    };
    this.updateBalanceValue(payload);
  }
  updateBalanceValue(payload) {
    this.subscription.add(
      this.shareService.updateBalanceEntry(payload).subscribe(
        (response) => {
          this.getBalance();
        },
        (error) => {
          this.toastr.error(error);
        }
      )
    );
  }
  async addNewEntry(balanceData?: any) {
    const dialogRef = this.dialog.open(AttributesDialogComponent, {
      width: '550',
      height: 'auto',
      minHeight:
        this.data?.attribute?.value?.inputs?.length > 3 && this.data?.attribute?.value?.vault_form_code !== 'has_premium' ? '386px' : '275px',
      panelClass: 'attributes-dialog',
      data: {
        mode: 'create',
        title: this.getAttributeTitle(balanceData, this.data),
        userId: this.data.currentVaultUserId,
        currentFormId: this.data.currentFormId,
        triggeredFrom: 'register-balance',
        expenseCategories: [],
        existingAttributesList: this.data.attribute,
        attributeData: {},
        getFormValues: this.getFormValues(this.data.attribute?.key),
        attributeType: EAttributesTypes.financialAttribute,
        balanceData: balanceData ?? undefined,
        attribute_type: this.data.attribute_type,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          this.getBalance();
        }
      })
    );
  }

  getAttributeTitle(balanceData, data) {
    const key = data?.attribute?.key;

    if (balanceData) {
      if (key === 'Add Distribution') return 'Edit Distribution';
      if (key === 'Add Contribution') return 'Edit Contribution';
    }

    return key;
  }

  getAttributeValue(key: string, Object: any) {
    const data = JSON.parse(Object?.additional_data);
    if (key === 'distribution_type') {
      return data[key];
    }
    let value = (data[key] ?? `${0}`)?.toString().replace(/,/g, '');
    return parseFloat(value) ?? 0;
  }
  getCurrency(Object: any) {
    const data = JSON.parse(Object?.additional_data);
    if (data['currency_type']) {
      if (data['currency_type']?.toLowerCase() == 'usd') {
        return 'USD';
      } else if (data['currency_type']?.toLowerCase() == 'pounds sterling') {
        return 'GBP';
      } else if (data['currency_type']?.toLowerCase() == 'euro') {
        return 'EUR';
      } else if (data['currency_type']?.toLowerCase() == 'cad') {
        return 'CAD';
      }
    }

    return 'USD';
  }

  // getAttributeValueTwo(i) {
  //   const data = JSON.parse(this.registerArray[i].additional_data);
  //   return parseFloat(data[`${this.attributesList[2].replace(/\s+/g, '_').toLowerCase()}`]?.replace(/,/g, '')) ?? '';
  // }
  getFormValues(title: string) {
    if (!!this.financialAttributes) {
      const attribute = this.financialAttributes?.find((attribute) => attribute?.type == title);
      if (!!attribute) return Object.entries(JSON.parse(attribute?.value));
      if (!!!attribute) return null;
    } else {
      return undefined;
    }
    return undefined;
  }
  addBalanceForm(data): FormGroup {
    return this._formBuilder.group({
      id: new FormControl(data.id),
      date: new FormControl(data.effective_date),
      add: new FormControl(true),
      // source: new FormControl('manual'),
      value: new FormControl(data.value),
      action: new FormControl('newRecord'),
      isDateEditable: new FormControl(true),
      isAmountEditable: new FormControl(false),
      isNewRow: new FormControl(true),
      selected: new FormControl(false),
    });
  }

  updateEntryEvent(RegisterFormElement, i, updateType = '', createMode = false) {
    let id = RegisterFormElement.get('RegisterRows').at(i).get('id').value;
    let effective_date = RegisterFormElement.get('RegisterRows').at(i).get('date').value;
    let amount = RegisterFormElement.get('RegisterRows').at(i).get('value').value
      ? RegisterFormElement.get('RegisterRows').at(i).get('value').value
      : 0;
    amount = `${amount}`.replace(/,/g, '');

    let formateEffectiveDate = moment(effective_date).add(6, 'hours').utc();
    if (updateType == 'updateDate') {
      if (this.receivedData?.attribute?.value?.Register_keys?.includes('Date')) {
        RegisterFormElement.get('RegisterRows').at(i).get('isDateEditable').patchValue(true);
        RegisterFormElement.get('RegisterRows').at(i).get('isAmountEditable').patchValue(true);
      }
    }
    if (updateType == 'updateAmount') {
      RegisterFormElement.get('RegisterRows').at(i).get('isAmountEditable').patchValue(true);
      RegisterFormElement.get('RegisterRows').at(i).get('isDateEditable').patchValue(true);
    }
    if (!amount) RegisterFormElement.get('RegisterRows').at(i).get('value').patchValue(0);
    this.updateBalance(id, formateEffectiveDate, amount, createMode);
  }

  changeCategory(event, RegisterFormElement, i, updateType) {
    (this.RegisterForm.get('RegisterRows') as FormArray)['at'](i).get('category').patchValue(event.name);
    this.editCategoryClicked = false;
    this.selectedCategories = event.selectedCategories;
    this.updateEntryEvent(RegisterFormElement, i, updateType);
  }

  editRegisterEntry(RegisterFormElement, i, editType = '', transactionType = '') {
    let id = RegisterFormElement.get('RegisterRows').at(i).get('id').value;
    let effective_date = RegisterFormElement.get('RegisterRows').at(i).get('date').value;
    let formateEffectiveDate = moment(effective_date).add(6, 'hours').utc();
    let amount = RegisterFormElement.get('RegisterRows').at(i).get('value').value
      ? RegisterFormElement.get('RegisterRows').at(i).get('value').value
      : 0;
    amount = `${amount}`.replace(/,/g, '');

    if (
      this.dataSource.data.length >= 1 &&
      i != 0 &&
      !(this.RegisterForm.get('RegisterRows') as FormArray)['at'](0).get('isAmountEditable').value &&
      (this.RegisterForm.get('RegisterRows') as FormArray)['at'](0).get('isNewRow').value
    ) {
      this.updateEntryEvent(RegisterFormElement, 0, editType);
    }
    if (editType == 'editAmount') RegisterFormElement.get('RegisterRows').at(i).get('isAmountEditable').patchValue(false);
    if (editType == 'editDate' && this.receivedData?.attribute?.value?.Register_keys?.includes('Date'))
      RegisterFormElement.get('RegisterRows').at(i).get('isDateEditable').patchValue(false);
    // this.updateBalance(id, formateEffectiveDate, amount, false);
  }

  openTaskItemDialog(RegisterFormElement, i) {
    const dialogRef = this.dialog.open(TaskItemDialogComponent, {
      width: '390px',
      panelClass: 'take-dialog-component',
      data: {
        triggeredFrom: this.allTransaction ? 'all-transaction-register' : 'transaction-register',
        ...(this.allTransaction && {
          linked_vault_user_form_id: (this.RegisterForm.get('RegisterRows') as FormArray)['at'](i).get('linked_vault_user_form_id').value,
          linked_vault_user_form_name: (this.RegisterForm.get('RegisterRows') as FormArray)['at'](i).get('linked_vault_user_form_name').value,
        }),
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data != undefined && data['item_name']) {
          this.fid = data['item_fid'];
          if (data['item_id'] != null) {
            this.linkedItemArray.push(parseInt(data['item_id']));
            (this.RegisterForm.get('RegisterRows') as FormArray)['at'](i).get('linked_vault_user_form_id').patchValue(data['item_id']);
            (this.RegisterForm.get('RegisterRows') as FormArray)['at'](i).get('linked_vault_user_form_name').patchValue(data['item_name']);
            this.updateEntryEvent(this.RegisterForm, i, 'updateLink');
          }
          this.changeDetector.detectChanges();
        }
        if (data && data['delete']) {
          (this.RegisterForm.get('RegisterRows') as FormArray)['at'](i).get('linked_vault_user_form_id').patchValue(null);
          (this.RegisterForm.get('RegisterRows') as FormArray)['at'](i).get('linked_vault_user_form_name').patchValue(null);
          this.updateEntryEvent(this.RegisterForm, i, 'updateLink');
        }
      })
    );
  }

  selectEntry(event, RegisterFormElement, balance, i) {
    if (event.source.checked) {
      this.selectedRowIndex = i;
      RegisterFormElement.get('RegisterRows').at(i).get('selected').patchValue(true);
      this.selectedEntryArray.push(balance.value);
      this.selectedEntryArray = [...new Set(this.selectedEntryArray)];

      const incomeTypeCategory = this.selectedEntryArray.every((selectedEntry) => selectedEntry.type === 'income');
      const expenseTypeCategory = this.selectedEntryArray.every((selectedEntry) => selectedEntry.type === 'expense');
      if (incomeTypeCategory) this.transactionType = 'income';
      if (expenseTypeCategory) this.transactionType = 'expense';
      this.disableCategoryButton = !incomeTypeCategory && !expenseTypeCategory ? true : false;

      let canBeReviewed = this.selectedEntryArray.filter((selectedEntry) => {
        return selectedEntry.category !== 'Uncategorized Income' && selectedEntry.category !== 'Uncategorized Expense';
      });
      let canBeDeleted = this.selectedEntryArray.filter((selectedEntry) => {
        return selectedEntry.source == 'manual';
      });
      let reviewed = this.selectedEntryArray.filter((selectedEntry) => {
        return selectedEntry.is_reviewed == true;
      });
      let notReviewed = this.selectedEntryArray.filter((selectedEntry) => {
        return !selectedEntry.is_reviewed;
      });
      this.checkReviewStatus =
        this.selectedEntryArray.length == reviewed.length ? 'reviewed' : this.selectedEntryArray.length == notReviewed.length ? 'unreviewed' : '';
      this.disableReviewButton =
        this.selectedEntryArray.length != canBeReviewed.length
          ? true
          : this.selectedEntryArray.length != reviewed.length && this.selectedEntryArray.length != notReviewed.length
          ? true
          : false;
      this.disableDeleteButton = this.selectedEntryArray.length != canBeDeleted.length ? true : false;
    } else if (!event.source.checked) {
      RegisterFormElement.get('RegisterRows').at(i).get('selected').patchValue(false);
      this.selectAll = false;
      this.selectedRowIndex = -1;
      this.selectedEntryArray = this.selectedEntryArray.filter((deselectedBalance) => {
        return deselectedBalance.id != balance.value.id;
      });

      const incomeTypeCategory = this.selectedEntryArray.every((selectedEntry) => selectedEntry.type === 'income');
      const expenseTypeCategory = this.selectedEntryArray.every((selectedEntry) => selectedEntry.type === 'expense');
      if (incomeTypeCategory) this.transactionType = 'income';
      if (expenseTypeCategory) this.transactionType = 'expense';
      this.disableCategoryButton = !incomeTypeCategory && !expenseTypeCategory ? true : false;

      let canBeReviewed = this.selectedEntryArray.filter((selectedEntry) => {
        return selectedEntry.category !== 'Uncategorized Income' && selectedEntry.category !== 'Uncategorized Expense';
      });
      let canBeDeleted = this.selectedEntryArray.filter((selectedEntry) => {
        return selectedEntry.source == 'manual';
      });
      let reviewed = this.selectedEntryArray.filter((selectedEntry) => {
        return selectedEntry.is_reviewed == true;
      });
      let notReviewed = this.selectedEntryArray.filter((selectedEntry) => {
        return !selectedEntry.is_reviewed;
      });
      this.checkReviewStatus =
        this.selectedEntryArray.length == reviewed.length ? 'reviewed' : this.selectedEntryArray.length == notReviewed.length ? 'unreviewed' : '';
      this.disableReviewButton =
        this.selectedEntryArray.length != canBeReviewed.length
          ? true
          : this.selectedEntryArray.length != reviewed.length && this.selectedEntryArray.length != notReviewed.length
          ? true
          : false;
      // this.disableReviewButton = this.selectedEntryArray.length != canBeReviewed.length ? true : false;
      this.disableDeleteButton = this.selectedEntryArray.length != canBeDeleted.length ? true : false;
    }
    if (this.registerArray.length == this.selectedEntryArray.length) {
      this.selectAll = true;
    }
    this.changeDetector.detectChanges();
  }

  selectAllEntry(event) {
    if (event.source.checked) {
      this.selectAll = true;
      Object.keys(this.RegisterForm.controls).forEach((key, index) => {
        this.RegisterForm.controls[key].value.forEach((element, index) => {
          const selected = (this.RegisterForm.get('RegisterRows') as FormArray)['at'](index).get('selected').patchValue(true);
          this.selectedEntryArray = this.RegisterForm.controls[key].value;
          this.selectedEntryArray = [...new Set(this.selectedEntryArray)];
          let canBeReviewed = this.selectedEntryArray.filter((selectedEntry) => {
            return selectedEntry.category !== 'Uncategorized Income' && selectedEntry.category !== 'Uncategorized Expense';
          });
          let canBeDeleted = this.selectedEntryArray.filter((selectedEntry) => {
            return selectedEntry.source == 'manual';
          });
          let reviewed = this.selectedEntryArray.filter((selectedEntry) => {
            return selectedEntry.is_reviewed == true;
          });
          let notReviewed = this.selectedEntryArray.filter((selectedEntry) => {
            return !selectedEntry.is_reviewed;
          });
          this.checkReviewStatus =
            this.selectedEntryArray.length == reviewed.length ? 'reviewed' : this.selectedEntryArray.length == notReviewed.length ? 'unreviewed' : '';
          this.disableReviewButton =
            this.selectedEntryArray.length != canBeReviewed.length
              ? true
              : this.selectedEntryArray.length != reviewed.length && this.selectedEntryArray.length != notReviewed.length
              ? true
              : false;
          // this.disableReviewButton = this.selectedEntryArray.length != canBeReviewed.length ? true : false;
          this.disableDeleteButton = this.selectedEntryArray.length != canBeDeleted.length ? true : false;
        });
      });
    } else {
      this.selectAll = false;
      this.disableReviewButton = false;
      this.disableDeleteButton = false;
      this.selectedEntryArray = [];
      Object.keys(this.RegisterForm.controls).forEach((key, index) => {
        this.RegisterForm.controls[key].value.forEach((element, index) => {
          (this.RegisterForm.get('RegisterRows') as FormArray)['at'](index).get('selected').patchValue(false);
        });
      });
    }
    this.changeDetector.detectChanges();
  }

  closeTaskChecklist(event?: any) {
    this.selectedEntryArray = [];
    this.selectAll = false;
    Object.keys(this.RegisterForm.controls).forEach((key, index) => {
      this.RegisterForm.controls[key].value.forEach((element, index) => {
        const isSelected = (this.RegisterForm.get('RegisterRows') as FormArray)['at'](index).get('selected').value;
        (this.RegisterForm.get('RegisterRows') as FormArray)['at'](index).get('selected').patchValue(false);
      });
    });
    this.changeDetector.detectChanges();
  }

  closeDialog() {
    if (
      this.dataSource.data.length >= 1 &&
      this.data.registerType == 'balance' &&
      !(this.RegisterForm.get('RegisterRows') as FormArray)['at'](0).get('isAmountEditable').value
    ) {
      (this.RegisterForm.get('RegisterRows') as FormArray)['at'](0).get('isAmountEditable').patchValue(true);
      if ((this.RegisterForm.get('RegisterRows') as FormArray)['at'](0).get('isAmountEditable').value) {
        this.updateBalance(
          (this.RegisterForm.get('RegisterRows') as FormArray)['at'](0).get('id').value,
          (this.RegisterForm.get('RegisterRows') as FormArray)['at'](0).get('date').value,
          (this.RegisterForm.get('RegisterRows') as FormArray)['at'](0).get('value').value
        );
        this.closeTransactionDialog.emit();
      }
    } else if (
      this.dataSource.data.length >= 1 &&
      this.data.registerType == 'transaction' &&
      !(this.RegisterForm.get('RegisterRows') as FormArray)['at'](0).get('isAmountEditable').value
    ) {
      (this.RegisterForm.get('RegisterRows') as FormArray)['at'](0).get('isAmountEditable').patchValue(true);
      if ((this.RegisterForm.get('RegisterRows') as FormArray)['at'](0).get('isAmountEditable').value) {
        this.updateEntryEvent(this.RegisterForm, 0);
        this.closeTransactionDialog.emit();
      }
    } else {
      this.closeTransactionDialog.emit();
    }
  }

  getFormattedDate(date) {
    let dt = new Date(date);
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    const formatteddDate = months[dt.getMonth()] + ' ' + dt.getDate() + ', ' + dt.getFullYear();
    return formatteddDate;
  }

  calculateBalanceChange(balancearray, index) {
    const changevalue =
      balancearray.length > 1 && index < balancearray.length - 1
        ? ((balancearray[index].value - balancearray[index + 1].value) / Math.abs(balancearray[index + 1].value)) * 100
        : 0;
    this.infinityValue = Number.isFinite(changevalue);
    return changevalue;
  }

  selectAllContent($event) {
    $event.target.select();
  }

  removeLinkedItem(RegisterFormElement, i) {
    RegisterFormElement.get('RegisterRows').at(i).get('linked_vault_user_form_id').patchValue(null);
    RegisterFormElement.get('RegisterRows').at(i).get('linked_vault_user_form_name').patchValue(null);
    this.changeDetector.detectChanges();
  }

  updateTable() {
    this.RegisterForm = this._formBuilder.group({
      RegisterRows: this._formBuilder.array(
        (!this.showReviewedItems
          ? this.showReviewedItemsOnly
            ? this.registerArray.filter((data) => data.is_reviewed)
            : this.registerArray.filter((data) => !data.is_reviewed)
          : this.registerArray
        ).map((val, index) =>
          this._formBuilder.group({
            id: new FormControl(val.id),
            date: new FormControl(val.effective_date),
            merchant: new FormControl(val.merchant != null ? val.merchant.logo_url : ''),
            description: new FormControl(val.description),
            category: new FormControl(val.category),
            linked_vault_user_form_id: new FormControl(val.linked_vault_user_form_id),
            linked_vault_user_form_name: new FormControl(val.linked_vault_user_form_name),
            vault_user_form_name: new FormControl(val?.vault_user_form_name),
            profile_image_url: new FormControl(val?.profile_image_url),
            source: new FormControl(val.source),
            type: new FormControl(val.type),
            value: new FormControl(val.value),
            is_reviewed: new FormControl(val.is_reviewed),
            action: new FormControl('existingRecord'),
            isDateEditable: new FormControl(true),
            isDescriptionEditable: new FormControl(true),
            isCategoryEditable: new FormControl(true),
            isLinkEditable: new FormControl(true),
            isAmountEditable: new FormControl(true),
            isNewRow: new FormControl(false),
            selected: new FormControl(false),
          })
        )
      ),
    });
    this.dataSource = new MatTableDataSource((this.RegisterForm.get('RegisterRows') as FormArray).controls);
    this.changeDetector.detectChanges();
  }
  sortByDate() {
    this.defaultSort = 'date';
    this.sortedArrayByReview = false;
    if (this.sortedArrayByDate == false) {
      const sortedByEffectiveDate = this.registerArray
        .slice()
        .sort((a, b) => new Date(a.effective_date).getTime() - new Date(b.effective_date).getTime());
      this.registerArray = [...sortedByEffectiveDate];
      this.sortedArrayByDate = !this.sortedArrayByDate;
    } else {
      const sortedArrayByDate = this.registerArray
        .slice()
        .sort((a, b) => new Date(b.effective_date).getTime() - new Date(a.effective_date).getTime());
      this.registerArray = [...sortedArrayByDate];
      this.sortedArrayByDate = !this.sortedArrayByDate;
    }
    this.updateTable();
  }

  select(query: string): BankGroup[] {
    let result: BankGroup[] = [];
    for (let a of this.areas) {
      if (a.name.toLocaleLowerCase().includes(query.toLocaleLowerCase())) {
        result.push(a);
      } else {
        let filterData = a.banks.filter((x) => x.name.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
        if (filterData.length) {
          let pushData = a;
          pushData.banks = a.banks.filter((x) => x.name.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
          result.push(pushData);
        }
      }
    }
    return result;
  }

  toggleTransactionView(event) {
    event.preventDefault();
    this.showReviewedItems = !this.showReviewedItems;
    this.updateTable();
  }

  focusOutFunction() {
    this.isOpen = !this.isOpen;
    if (!this.isOpen) {
      eval(`document.getElementById('input-category-search').value='';`);
      // this.search('');
    }
  }

  openedChange(RegisterFormElement, i, $event) {
    this.updateEntryEvent(RegisterFormElement, i, 'updateCategory');
  }

  closedChange(RegisterFormElement, i, $event) {
    RegisterFormElement.get('RegisterRows').at(i).get('isCategoryEditable').patchValue(true);
    this.editCategoryClicked = false;
  }

  editLink(RegisterFormElement, index) {
    RegisterFormElement.get('RegisterRows').at(index).get('isLinkEditable').patchValue(false);
    this.changeDetector.detectChanges();
  }

  removeLink(RegisterFormElement, index) {
    RegisterFormElement.get('RegisterRows').at(index).get('linked_vault_user_form_name').patchValue(null);
    RegisterFormElement.get('RegisterRows').at(index).get('linked_vault_user_form_id').patchValue(null);
    // this.updateEntryEvent(RegisterFormElement, index, 'updateDescription');
    this.changeDetector.detectChanges();
  }

  ShowChildOptionEstate(ev: Event, option) {
    ev.stopPropagation();
    ev.preventDefault();
  }

  SelectChildOptionEstate($event, i, currentData) {
    this.selectedAreas.forEach((element) => {
      element.isOpen = false;
    });
  }

  getValue(event, i, f) {
    // const strFix = `${event}`.replace(/,/g, '');
    // f.get('RegisterRows').at(i).get('value').patchValue(strFix);
    // const strFIx = `${event}`.replace(/,/g, '');
    f.get('RegisterRows').at(i).get('value').patchValue(event);
  }

  focusoutEvent(event) {}

  async getAllCategoriesBasedOnType(transactionType) {
    this.subscription.add(
      this.userService.getAllCategoriesBasedOnType(transactionType).subscribe(
        (res) => {
          if (transactionType == 'income') this.incomeCategories = [...res];
          if (transactionType == 'expense') this.expenseCategories = [...res];
          this.selectedCategories = [...this.incomeCategories, ...this.expenseCategories];
          this.selectedCategories.forEach((element) => {
            element.isOpen = false;
          });
          this.changeDetector.detectChanges();
        },
        (error: any) => {
          this.toastr.error('Error occurred while getting income categories');
        }
      )
    );
  }

  checkIfUserCanCreateIncomeExpenseCategory() {
    this.subscription.add(
      this.userService.checkIfUserCanCreateIncomeExpenseCategory(this.data.currentFormId).subscribe(
        (res) => {
          this.canCreateIncomeExpense = res;
          this.changeDetector.detectChanges();
        },
        (error: any) => {
          this.toastr.error('Error occurred while getting expense categories');
        }
      )
    );
  }

  async OpenCategoryDropdown(i) {
    if (i > 5) {
      let g = (i - 5).toString();
      const selectedRow = document.getElementById(i + 1) ?? document.getElementById(i);
      if (selectedRow) {
        selectedRow.scrollIntoView({ behavior: 'auto', block: 'center' });
      }
    }
    // await this.categorySelect.open();
  }

  getWidthInAllTransaction(): string {
    if (this.isExpenseIncomeCategoryDropdownOpen && this.isBrowserSafari && this.allTransaction) {
      return 'calc(99.8% - 8px) !important';
    } else {
      return '99.8%';
    }
  }

  editBalance(RegisterFormElement, i) {
    let id = RegisterFormElement.get('RegisterRows').at(i).get('id').value;
    let exist = this.registerArray.find((item) => item.id == id);
    exist = { ...exist, unstringData: JSON.parse(exist.additional_data) };
    this.addNewEntry(exist);
  }
  deleteBalance(RegisterFormElement, i) {
    let id = RegisterFormElement.get('RegisterRows').at(i).get('id').value;
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '500px',
      data: {
        title: 'Delete Record?',
        materialIcon: 'delete',
        text: `Are you sure you want to delete this record?`,
        proceedTitle: 'Delete',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.handleDeleteBalanceData({
            ids: [id],
            vault_user_form_id: this.receivedData?.currentFormId,
          });
        }
      })
    );
  }

  handleDeleteBalanceData(payload) {
    this.subscription.add(
      this.shareService.deleteBalanceEntry(payload).subscribe(() => {
        this.getBalance();
        this.closeTaskChecklist();
      })
    );
  }
  getSumOfCommitments(transactions) {
    let totalAmount = 0;

    for (const transaction of transactions) {
      const additionalData = JSON.parse(transaction.additional_data);

      const amount = additionalData.value || 0;
      totalAmount += amount;
    }
    return totalAmount;
  }
  convertObjectValuesToNumbers(obj) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === 'string' && !isNaN((value as any).replace(/,/g, ''))) {
        result[key] = parseFloat(value.replace(/,/g, ''));
      } else {
        result[key] = value;
      }
    }
    return result;
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
